<template>
    <div
        class="tw:w-full tw:py-3 tw:sm:py-4 tw:mb-4 tw:sm:mb-6 tw:border-b tw:border-slate-200/60 tw:flex tw:items-center tw:justify-between tw:flex-wrap tw:gap-3 tw:sm:gap-4">
        <!-- Título ha Breadcrumbs -->
        <div class="tw:flex-1 tw:min-w-0 tw:sm:min-w-[240px]">
            <h4 class="tw:text-slate-900 tw:text-lg tw:sm:text-xl tw:font-bold tw:tracking-tight tw:m-0 tw:mb-1 tw:break-words">{{ title }}</h4>
            <nav aria-label="Breadcrumb">
                <ul
                    class="tw:flex tw:items-center tw:gap-2 tw:text-sm tw:text-slate-500 tw:m-0 tw:p-0 tw:list-none tw:flex-wrap">
                    <li>
                        <router-link to="/"
                            class="tw:text-slate-500 tw:no-underline tw:hover:text-primary tw:transition-colors">
                            <i class="fas fa-home tw:mr-1"></i> Dashboard
                        </router-link>
                    </li>
                    <div v-for="(bread, index) in list_breadcrumb" :key="'sep' + index">
                        <li class="tw:text-slate-300">/</li>
                        <li>
                            <router-link to="/reservations"
                                class="tw:text-slate-500 tw:no-underline tw:hover:text-primary tw:transition-colors">
                                {{ bread }}
                            </router-link>
                        </li>
                    </div>
                    <li class="tw:text-slate-300">/</li>
                    <li class="tw:text-slate-800 tw:font-semibold">{{ title }}</li>
                </ul>
            </nav>
        </div>

        <!-- Botón de Retorno (Back) -->
        <div class="tw:shrink-0 tw:text-right">
            <BackPage />
        </div>
    </div>
</template>

<script>
import BackPage from './BackPage.vue';
export default {
    name: 'BreadcrumbPage',
    props: {
        title: {
            type: String,
            required: true
        },
        list_breadcrumb: {
            type: Array,
            default: () => []
        }
    },
    components: {
        BackPage,
    }
}
</script>